/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function($){
    window.validationMultiNiveau = {};
    var buttonAnnulerMultiNiveau = document.querySelector('.js-annuler-multi-niveau');
    var inputNiveauAppDemande = document.querySelector('input[name="NIVEAU_APPROBATION_DEMANDE"]');
    var inputListeValidateur = document.querySelector('input[name="LISTE_VALIDATEURS"]');
    var textValidateur = document.querySelector('textarea[name="VALIDATEURS"]');
    var inputNiveauValidation = document.querySelector('input[name="NIVEAU_VALIDATION"]');
    if(buttonAnnulerMultiNiveau){
        buttonAnnulerMultiNiveau.addEventListener('click',function () {
            if(inputNiveauAppDemande){
                inputNiveauAppDemande.value = '';
            }
            if(inputListeValidateur){
                inputListeValidateur.value = '';
            }
            if(textValidateur){
                textValidateur.value = textValidateur.getAttribute('data-default-value');
            }
            if(inputNiveauValidation){
                inputNiveauValidation.value =  inputNiveauValidation.getAttribute('data-default-value');
            }
        });
    }
    validationMultiNiveau.afficherPopin = function(niveauApprobation,codeObjet,codeRubrique,codeRattachement,publicVise){
        validationMultiNiveau.popin = $.iframePopin({
            title : LOCALE_BO.validation.titre,
            url :'/servlet/com.jsbsoft.jtf.core.SG?PROC=VALIDATION&ACTION=APPROBATION&NIVEAU_APPROBATION='+niveauApprobation+'&CODE_OBJET='+codeObjet+'&CODE_RUBRIQUE='+codeRubrique+'&CODE_RATTACHEMENT='+codeRattachement+'&PUBLIC_VISE_DSI='+publicVise,
            autoOpen: true,
            resizable: false,
            width: 700,
            buttons: {},
            onClose: function() {
                this.destroy();
            }
        });
        var registeredId = iFrameHelper.registeriFrame({
            onSendValues: function(object){
                if(object){
                    if(object.niveauApprobationDemande && inputNiveauAppDemande){
                        inputNiveauAppDemande.value = object.niveauApprobationDemande;
                    }
                    if(object.listeValidateur && inputListeValidateur){
                        inputListeValidateur.value = object.listeValidateur;
                    }
                    if(object.validateur && textValidateur){
                        textValidateur.textContent = object.validateur;
                    }
                    if(object.niveauValidation && inputNiveauValidation){
                        inputNiveauValidation.value = object.niveauValidation;
                    }
                }
                validationMultiNiveau.popin.destroy();
                iFrameHelper.unregisteriFrame(registeredId);
            },
            onAbort: function(){
                validationMultiNiveau.popin .destroy();
                iFrameHelper.unregisteriFrame(registeredId);
            },
            iFrame: validationMultiNiveau.popin .iFrame,
            caller: this
        });
    };
})(jQuery.noConflict());
